/**
 * 接入的第三方相关api
 */
import * as http from '../http.js';

export const accessAPI = {
    // 获取企业用户信息接口
    getTripartiteEnterpriseInfo(query) {
        return http.post(`/system-api/sjsToken/getWebUser`, query, {
            headers: {
                "shield": "none"
            }
        })
    },
    // 获取科委用户信息接口
    getTripartiteExamine(query) {
        return http.post(`/system-api/sjsToken/getIntranetUser`, query, {
            headers: {
                "shield": "none"
            }
        })
    }
}